<template>
  <v-data-table :headers="headers" :items="filteredTreatments" sort-by="name" class="elevation-1">
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Tratamentos</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">Novo Tratamento</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.name" label="Nome do Tratamento"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">
        mdi-pencil
      </v-icon>
      <v-icon small @click="deleteItem(item)">
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Treatments",
  data() {
    return {
      search: "",
      dialog: false,
      headers: [
        {
          text: "Nome",
          align: "start",
          sortable: false,
          value: "name"
        },
        { text: "Ações", value: "actions", sortable: false }
      ],
      editedIndex: -1,
      editedItem: {
        name: ""
      },
      defaultItem: {
        name: ""
      }
    };
  },

  methods: {
    ...mapActions(["fetchTreatments"]),
    editItem(item) {
      this.editedIndex = this.filteredTreatments.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.filteredTreatments.indexOf(item);
      confirm("Eliminar Tratamento?") && this.filteredTreatments.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        //Editado
        // Object.assign(this.filteredTreatments[this.editedIndex], this.editedItem);
      } else {
        //Novo
        // this.filteredTreatments.push(this.editedItem);
      }
      this.close();
    }
  },
  computed: {
    ...mapGetters(["allTreatments"]),
    filteredTreatments: function() {
      return this.allTreatments.filter(treatment => {
        return treatment.name.match(this.search);
      });
    },
    formTitle() {
      return this.editedIndex === -1 ? "Novo Tratamento" : "Editar Tratamento";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    this.fetchTreatments();
  }
};
</script>

<style>
#treatments {
  width: 100%;
  margin-top: 15px;
  padding-bottom: 10px;
}

#treatments td,
#treatments th {
  border: 1px solid #ddd;
  padding: 8px;
}

#treatments tr:nth-child(even) {
  background-color: #f2f2f2;
}

#treatments tr:hover {
  background-color: #ddd;
}

#treatments th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;

  color: black;
}
</style>
